<template>
	<v-card
		flat
		color="secondary"
		height="100%"
	>
		<v-card-text>
			<!-- <v-layout 
				row
				wrap 
				align-center
			>
				<h6 class="title">
					Estate shares
				</h6>
				<v-flex xs2>
					<v-text-field 
						v-model="sharesNumber" 
						type="number"
					/>
				</v-flex>
				<h6 class="title">
					/ 10
				</h6>
			</v-layout> -->

			<v-layout row wrap>
				<v-flex xs6>
				<h6 class="title">
					Value RE20: {{ selectedEstate.buy_cost }}
				</h6>
				<div class="title font-weight-light caption">amount + Fee 0,2%</div>
				</v-flex>

			</v-layout>
		</v-card-text>
		
		<v-card-actions>
			<v-spacer />
			<v-btn color="success" :disabled="selectedEstate.owner == this.metamaskAccount" @click="showBuyAlert()">
				Buy
			</v-btn>
			<v-btn color="orange" :disabled="((selectedEstate.owner != this.metamaskAccount) || (selectedEstate.owner == this.metamaskAccount && selectedEstate.for_sale == true))" @click="showSellAlert()">
				Sell
			</v-btn>
		</v-card-actions>
	</v-card>
</template>

<script>
import { mapMutations, mapState, mapActions, mapGetters } from 'vuex'
import { constants } from 'fs';


export default {
	props: ['selectedEstate'],
  
	data () {
		return {
			sharesNumber: 0
		}
	},
	methods: {
		...mapMutations (['SHOW_ALERT']),
		...mapActions (['setEstateForSale']),

		showBuyAlert () {
			// If the type of one of the two quantity is an object means that the amount is a big number: cast it to number
			let buy_cost = this.selectedEstate.buy_cost
			let tokenRE20 = parseFloat (this.tokenRE20)

			if (typeof (this.selectedEstate.buy_cost) === 'object') {
				buy_cost = buy_cost.toNumber()
			}
			
			if (buy_cost > tokenRE20) {
				this.SHOW_ALERT ({
					text: 'Warning',
					message: 'You don\'t have enough RE20 to go on.',
					dismissable: true,
					actions: []
				})
			} else {
				this.SHOW_ALERT ({
					text: 'New purchase request',
					message: `You are going to buy <strong>${this.selectedEstate.name}</strong>.<br/> Are you sure that do you want to continue?`,
					dismissable: false,
					actions: [
						{
							text: 'YES',
							type: 'success',
							handler: () => {
								this.$emit ('onClickBuy')
							}
						},
						{
							text: 'NO',
							type: 'error',
							handler: () => {
							// Dismiss Alert
							}
						}
					]
				})
			}
		},

		showSellAlert () {
			this.SHOW_ALERT ({
				text: 'Attention!',
				message: `You are going to offer for sale <strong>${this.selectedEstate.name}</strong>.<br/> Are you sure that do you want to continue?`,
				dismissable: false,
				actions: [
					{
						text: 'YES',
						type: 'success',
						handler: () => {
							this.setEstateForSale (this.selectedEstate)
						}
					},
					{
						text: 'NO',
						type: 'error',
						handler: () => {
							// Dismiss Alert
						}
					}
				]
			})
		}
	},
	computed: {
		...mapGetters ([
			'tokenRE20'
		]),
		...mapState ({
			user: state => state.auth.user,
			metamaskAccount: state => state.wallet.defaultAccount,
		})
	}
}
</script>